import getD3Locale from './getD3Locale';

export default getD3Locale;
